export default __webpack_public_path__ + "static/corner-0d4010e1d3720871eb70d17ffb1adefa.png";